import { EmployeeImport } from './../../../model/common/import/employee-import';
import { Param } from './../../../model/common/param';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { Department } from '../../../model/api/administration/department';
import { Employee } from '../../../model/api/administration/employee';
import { EmployeeDetail } from '../../../model/api/administration/employee-detail';
import { EmployeeHttpService } from '../../../services/http/administration/employee.http.service';
import { EmployeeDetailHttpService } from '../../../services/http/administration/employee-detail.http.service';
import { EmployeeDetailComponent as EmployeeDetailUI } from './employee.detail';
import { Router } from '@angular/router';
import { saveAs as fileSaveAs } from 'file-saver-es';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EmployeeListComponent } from './employee.list';
import { DepartmentListComponent } from '../departments/department.list';
import { AppData } from '../../../app-data';
import { DepartmentHttpService } from '../../../services/http/administration/department.http.service';
import { AppUtils } from '../../../common/app.utils';
import { CostCenterListComponent } from '../cost-centers/cost-center.list';
import { CostCenter } from '../../../model/api/administration/cost-center';
import { CostCenterHttpService } from '../../../services/http/administration/cost-center.http.service';
import alasql from 'alasql';

@Component({
    selector: 'app-employee-manage',
    templateUrl: 'employee.manage.html',
})
export class EmployeeManageComponent extends GenericManage<Employee, number> {

    @ViewChild('employeeDetailModal') employeeDetailModal: ModalDirective;
    @ViewChild('employeeList') employeeList: EmployeeListComponent;
    @ViewChild('employeeDetail') employeeDetail: EmployeeDetailUI;
    @ViewChild('departmentListModal') departmentListModal: ModalDirective;
    @ViewChild('departmentList') departmentList: DepartmentListComponent;
    @ViewChild('costCenterListModal') costCenterListModal: ModalDirective;
    @ViewChild('costCenterList') costCenterList: CostCenterListComponent;
    @ViewChild('importDataModal') public importDataModal: ModalDirective;
    @ViewChild('fileInput') fileInput: ElementRef;

    @ViewChild('uploadModal') public uploadModal: ModalDirective;

    public filter: string = '';
    public selectedDepartment: Department = null;
    public selectedCostCenters: CostCenter[] = null;
    isCollapsed: boolean = true;
    pageSize = 10;
    public data;
    public importLines: Array<EmployeeImport> = new Array<EmployeeImport>();
    public noOfItems: number = 0;
    public showExportTemplateBtn = true;
    public importIndex: number = 0;
    public fileEvent: any = null;
    public deletedEmployees: boolean = false;
    public get isAdmin(): boolean { return AppData.UserIsAdmin; }

    constructor(public departmentHttpService: DepartmentHttpService,
                public costCenterHttpService: CostCenterHttpService,
                public employeeHttpService: EmployeeHttpService,
                public router: Router,
                public employeeDetailHttpService: EmployeeDetailHttpService) {

        super();
    }

    public syncEmp() {

        this.employeeHttpService.updateAllEmp().subscribe((count) => {
             alert('Au fost actualizati ' + JSON.stringify(count) + ' angajati!');
            // this.toastr.success('Au fost actualizati ' + JSON.stringify(count) + ' angajati!');
       });

}

    public showDeletedEmployees(){

        let params = new Array<Param>();
        params.push(new Param('deleted', JSON.stringify(this.deletedEmployees)));

        this.employeeList.refresh(params);

    }

    public addNewItem() {
        super.addNewItem();

        this.employeeDetail.department = null;
        this.employeeDetail.costCenter = null;
    }

    public editItem() {
        super.editItem();

        let employee: EmployeeDetail = this.selectedItem as EmployeeDetail;

        this.employeeDetail.department = null;
        if (employee != null) {
            this.departmentHttpService
                .getById(employee.departmentId)
                .subscribe((department: Department) => {
                    this.employeeDetail.department = department;
                });
        }
    }

    public detailInitialize() {
        super.detailInitialize();
        this.employeeDetailModal.show();
    }

    public detailTerminate() {
        super.detailTerminate();
        this.employeeDetailModal.hide();
    }

    public onEmployeeDetailDepartmentNeeded() {
        this.employeeDetailModal.hide();
        this.selectDepartment();
    }

    public onDepartmentListCancel() {
        this.departmentListModal.hide();
        this.employeeDetailModal.show();
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));
        params.push(new Param('pageSize', this.pageSize.toString()));
        // params.push(new Param('departmentId', this.selectedDepartment != null ? this.selectedDepartment.id.toString() : null));
        params.push(new Param("departmentIds", AppUtils.getIdsList<Department, number>([ this.selectedDepartment ])));
        params.push(new Param('deleted', JSON.stringify(this.deletedEmployees)));

        this.employeeList.refresh(params);
    }

    public selectDepartment() {
        this.departmentListModal.show();
        this.departmentList.refresh(null);
    }

    public setSelectedDepartment() {
        switch(this.viewMode) {
            case GenericManageViewMode.ItemList:
                this.selectedDepartment = this.departmentList.selectedItem;
                this.departmentListModal.hide();
                this.refresh();
                break;
            case GenericManageViewMode.ItemDetail:
                this.employeeDetail.department = this.departmentList.selectedItem;
                this.departmentListModal.hide();
                this.employeeDetailModal.show();
                break;
        }
    }

    public unselectDepartment() {
        this.selectedDepartment = null;
        this.refresh();
    }


    public loadFile(ev) {
        this.fileEvent = ev;
    }

    public doImportEmployees() {
        if (this.importIndex < this.importLines.length) {
            this.employeeDetailHttpService.upload(this.importLines[this.importIndex]).subscribe((data) => {
                this.importIndex = this.importIndex + 1;
                this.doImportEmployees();
            });
        }
        else {
            this.fileEvent = null;
            this.importDataModal.hide();
            this.importIndex = 0;
            this.importLines = new Array<EmployeeImport>();
        }
    }

    public importEmployees() {

        let fi = this.fileInput.nativeElement;
        if (fi.files && fi.files[0]) {
            let fileToUpload = fi.files[0];
            this.employeeHttpService
                .import(fileToUpload)
                .subscribe(res => {
                    if (res.status === 200){
                         alert('Employees have been successfully updated!');
                        // alert('Datele au fost actualizate cu success!');
                    }else{
                        alert('Error importing employees!');
                            // alert('Eroare import!');
                    }
                    this.refresh();
                }, (error) => {
                    alert('Error importing employees!');
                });
        }

    }

    // public importEmployees() {

    //     if (this.fileEvent === null) return;

    //     alasql.promise(`select
    //                         [ID] as [InternalCode],
    //                         [First Name] as [FirstName],
    //                         [Last Name] as [LastName],
    //                         [Email] as [Email],
    //                         [Supv ID] as [InternalCodeTl],
    //                         [Supervisor] as [FullNameTl],
    //                         [Dept] as [Department]
    //                         from FILE(?, {headers: true})`, [this.fileEvent])

    //         .then((importLines: Array<EmployeeImport>) => {

    //             this.importDataModal.show();

    //             this.importIndex = 0;
    //             this.importLines = importLines;

    //             this.doImportEmployees();
    //     });

    // }

    public getFilters(): Array<Param> {
        let params: Array<Param> = new Array<Param>();
        params.push(new Param('filter', this.filter));
        params.push(new Param("departmentIds", AppUtils.getIdsList<Department, number>([this.selectedDepartment])));
        params.push(new Param('deleted', JSON.stringify(this.deletedEmployees)));
        return params;
    }

    public exportToExcel() {

        let params: Array<Param> = null;

        params = this.getFilters();
        this.employeeHttpService
            .export(params)
            .subscribe((blob) => {
                fileSaveAs(blob, 'employees.xlsx');
            });
    }

    public editEmployee() {
        let selectedEmployeeId = this.employeeList.selectedItems.length > 0 ? this.employeeList.selectedItems[0].id : 0;
        if (selectedEmployeeId > 0) {
            this.router.navigate(['/employee', selectedEmployeeId]);
        }
    }


    
    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }

      public onPageUpdate(number: number) {
        this.pageSize = number;
        this.refresh();
    }

    public uploadEmployee() {

        this.uploadModal.show();
    }

    public importData() {
        this.uploadModal.hide();
        if (this.fileEvent === null) return;

        // console.log(JSON.stringify(this.fileITEvent));

        alasql.promise(`select
                            CAST([Nume] AS STRING) as [FirstName],
                            CAST([Prenume] AS STRING) as [LastName],
                            CAST([Email] AS STRING) as [Email]
                            from FILE(?, {headers: true})`, [this.fileEvent])
            .then((importLines: Array<EmployeeImport>) => {

                
                importLines.forEach(element => {
                    if(element.FirstName === 'undefined') {
                        element.FirstName = '';
                    }

                    if(element.LastName === 'undefined') {
                        element.LastName = '';
                    }

                    if(element.Email === 'undefined') {
                        element.Email = '';
                    }
                });


                
                // console.log(JSON.stringify(importLines));
                this.importDataModal.show();

                this.importIndex = 0;
                this.importLines = importLines;
                this.noOfItems = importLines.length;

                this.doImport();
        });
    }

    public doImport() {
        if (this.importIndex < this.importLines.length) {
            this.employeeHttpService.uploadEmployee(this.importLines[this.importIndex]).subscribe((data) => {
                this.importIndex = this.importIndex + 1;
                this.doImport();
            });
        }
        else {
            this.fileEvent = null;
            this.importDataModal.hide();
            this.importIndex = 0;
            this.importLines = new Array<EmployeeImport>();
            this.refresh();
        }
    }

    public exportTemplate() {

        this.showExportTemplateBtn = false;
    
        this.employeeHttpService
            .exportTemplate()
            .subscribe((blob) => {
        fileSaveAs(blob.body, 'SameDay-employee.xlsx');
        this.showExportTemplateBtn = true;
      });
    }

    
}

// enum EmployeeManageViewMode {
//     EmployeeList = 1,
//     EmployeeDetail = 2,
//     DepartmentList = 3
// }
